import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await api.get('/auth/me');
        setUser(response.data.user);
      } catch (error) {
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const forgotPassword = async (email) => {
    const response = await api.post('/auth/forgot-password', { email});
    return response.data;
  };

  const registerByAdmin = async (userData) => {
    console.log("register resp", userData)

    const response = await api.post('/auth/registerByAdmin', userData);
    // localStorage.setItem('token', response.data.token);
    // setUser(response.data.user);
    console.log("register resp", response)
    return response.data;
  };


  const verifyMail = async (key) => {
    const response = await api.get("/auth/verify_mail", {
      params: {
        verify_key: key,
      },
    });

    return response.data;
  };

  const verifyVendorMail = async (key) => {
    const response = await api.get("/vendor-auth/verify_mail", {
      params: {
        verify_key: key,
      },
    });

    return response.data;
  };

  const register = async (userData) => {
    const response = await api.post('/auth/register', userData);
    localStorage.setItem('token', response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    verifyMail,
    register,
    logout,
    verifyVendorMail,
    registerByAdmin,
    forgotPassword,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
